import { DatasetTable } from "./tables/DatasetTable";

export const DatasetTableDetail = () => <DatasetTable />;
